import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, shareReplay } from 'rxjs';
import { endpoints } from '../endpoints';
import { RemoveImageRequest } from '../models/app/requests/media.request';
import {
    FinalizedPermissionsResponse,
    Game,
    PermissionContext,
    PlayersProfilesData,
} from '../models/common.interface';

@Injectable({
    providedIn: 'root',
})
export class CommonService {
    constructor(private http: HttpClient) {}

    downloadFile(url: string) {
        return this.http.get(url, { responseType: 'blob' }).pipe(
            map((blobPart: BlobPart) => {
                return new Blob([blobPart], {
                    type: 'application/octet-stream',
                });
            }),
            shareReplay()
        );
    }

    removeImageFile(request: RemoveImageRequest) {
        let params = new HttpParams();
        params = params.append('mediaType', request.mediaType);

        return this.http.delete<void>(
            endpoints.media.children.getRemoveImageUrl(
                request.domain,
                request.targetId
            ),
            { params }
        );
    }

    fetchGamesList() {
        let params = new HttpParams();
        params = params.append('includeOptions', true);

        return this.http
            .get<Game[]>(endpoints.games.endpoint, {
                params,
            })
            .pipe(shareReplay());
    }

    fetchPlayersList() {
        return this.http.get<PlayersProfilesData[]>(
            endpoints.admin.children.getPlayers()
        );
    }
    fetchPermissionsRequest(
        userId: string,
        permissionContexts = []
    ): Observable<FinalizedPermissionsResponse> {
        return this.http.post<FinalizedPermissionsResponse>(
            endpoints.permissions.children.finalizedList(userId),
            {
                userIds: [userId],
                inputContext: {
                    permissionContexts: permissionContexts,
                },
            }
        );
    }
}
